<template>
    <div class="w-full">
        <div class="flex flex-wrap -mx-2">
            <div class="w-full lg:w-12/12 order-2 lg:order-1 px-2">
                <div class="mb-4 w-full">
<!--                    <div class="rounded-md bg-blue-50 p-4 mb-2 shadow-sm">-->
<!--                        <div class="flex">-->
<!--                            <div class="shrink-0">-->
<!--                                <InformationCircleIcon class="size-5 text-blue-400" aria-hidden="true" />-->
<!--                            </div>-->
<!--                            <div class="ml-3 flex-1 md:flex md:justify-between">-->
<!--                                <p class="text-sm text-blue-700">Оновлений дизайн та додаткові функції вже доступні.</p>-->
<!--                                <p class="mt-3 text-sm md:mt-0 md:ml-6">-->
<!--                                    <a href="#" class="font-medium whitespace-nowrap text-blue-700 hover:text-blue-600">-->
<!--                                        Деталі-->
<!--                                        <span aria-hidden="true"> &rarr;</span>-->
<!--                                    </a>-->
<!--                                </p>-->
<!--                            </div>-->
<!--                        </div>-->
<!--                    </div>-->
                    <div class="border-l-4 border-purple-500 bg-gradient-to-r from-purple-50 to-pink-50 p-4 mt-5 sm:mt-0 shadow-sm rounded-lg" v-if="blackFridayUpgradeAvailable">
                        <div class="flex">
                            <div class="shrink-0">
                                <span class="text-3xl">🛍️</span>
                            </div>
                            <div class="ml-3 flex-1">
                                <p class="text-sm font-bold text-purple-900">
                                    ⚡ {{ $t('subscription.black_friday.banner_title') }}
                                </p>
                                <p class="text-sm text-purple-800 mt-1">
                                    {{ $t('subscription.black_friday.banner_description') }}
                                </p>
                                <div class="mt-3 flex flex-col sm:flex-row sm:items-center gap-3">
                                    <router-link to="/subscription" class="inline-flex items-center justify-center rounded-md bg-gradient-to-r from-purple-600 to-pink-600 px-4 py-2 text-sm font-semibold text-white shadow-md hover:from-purple-700 hover:to-pink-700 transition-all">
                                        🌟 {{ $t('subscription.black_friday.upgrade_button') }}
                                    </router-link>
                                    <a :href="blackFridayTermsUrl" target="_blank" class="text-sm font-medium text-purple-700 hover:text-purple-900 hover:underline transition-all cursor-pointer">
                                        {{ $t('subscription.black_friday.terms_button') }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="border-l-4 border-yellow-400 bg-yellow-50 p-4 mt-5 sm:mt-0" v-if="storageUsedPercent >= 90 && !blackFridayUpgradeAvailable">
                        <div class="flex">
                            <div class="shrink-0">
                                <svg class="size-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true" data-slot="icon">
                                    <path fill-rule="evenodd" d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495ZM10 5a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 10 5Zm0 9a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" clip-rule="evenodd" />
                                </svg>
                            </div>
                            <div class="ml-3">
                                <p class="text-sm text-yellow-700">
                                    {{ $t('home.storage_warning') }} <b>{{ storageUsed }}</b> {{ $t('home.of') }} <b>{{ storageLimit }}</b>.
                                    <router-link to="/subscription" class="font-medium text-yellow-700 underline hover:text-yellow-600">{{ $t('home.increase_storage') }}</router-link>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="w-full flex items-center justify-items-between sm:border-b border-gray-200 mt-5 gap-1 sm:gap-0 sm:mt-0">
                        <div :class="{'w-full -mb-1 sm:mb-0': true, 'hidden': isMobileSearchOpened}">
                            <div>
                                <div>
                                    <nav class="-mb-px flex space-x-4 sm:space-x-8" aria-label="Tabs">
                                        <a v-for="tab in tabs" :key="tab.name" href="#" @click.prevent="tab.action" :class="[tab.current ? 'border-blue-600 text-blue-700' : 'border-transparent text-gray-500 hover:border-gray-200 hover:text-gray-700', 'flex border-b-2 px-1 py-2 sm:py-4 text-sm font-medium whitespace-nowrap']" :aria-current="tab.current ? 'page' : undefined">
                                            {{ tab.name }}
                                            <span v-if="tab.count" :class="[tab.current ? 'bg-blue-100 text-blue-700' : 'bg-gray-200 text-gray-900', 'ml-3 hidden rounded-full px-2.5 py-0.5 text-xs font-medium md:inline-block']">{{ tab.count }}</span>
                                        </a>
                                    </nav>
                                </div>
                            </div>
                        </div>
                        <div :class="{'w-full': true, 'hidden': !isMobileSearchOpened}">
                            <input
                                id="search"
                                name="search"
                                type="text"
                                v-model="searchQuery"
                                :placeholder="$t('home.search_placeholder')"
                                class="block w-full rounded-md bg-white px-2.5 py-1 text-base text-gray-900 outline-1 -outline-offset-1 outline-white shadow.xs placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-royal-blue-500 sm:text-sm/6 focus:bg-white" />
                        </div>
                        <div class="me-2 hidden sm:block" v-if="!showDeletedList">
                            <input
                                id="search"
                                name="search"
                                type="text"
                                v-model="searchQuery"
                                :placeholder="$t('home.search_placeholder')"
                                class="block w-full rounded-md bg-white px-2.5 py-1 text-base text-gray-900 outline-1 -outline-offset-1 outline-white shadow.xs placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-royal-blue-500 sm:text-sm/6 focus:bg-white" />
                        </div>
                        <div class="ml-auto sm:hidden items-center rounded-lg bg-gray-100 flex p-0.5" v-if="!showDeletedList">
                            <button
                                @click.prevent="isMobileSearchOpened = !isMobileSearchOpened"
                                type="button"
                                :class="['bg-white shadow-xs', 'cursor-pointer rounded-md p-1.5 text-gray-400 hover:bg-white hover:shadow-xs']"
                            >
                                <MagnifyingGlassIcon v-if="!isMobileSearchOpened" class="size-5" aria-hidden="true" />
                                <XMarkIcon v-if="isMobileSearchOpened" class="size-5" aria-hidden="true" />
                                <span class="sr-only">Use list view</span>
                            </button>
                        </div>
                        <div v-if="!showDeletedList">
                            <Menu as="div" class="relative inline-block text-left sm:mr-2">
                                <div>
                                    <MenuButton class="inline-flex w-full justify-center gap-x-1.5 rounded-md bg-white p-1.5 text-sm font-semibold text-gray-900 shadow-xs hover:bg-gray-50 cursor-pointer">
                                        <BarsArrowDownIcon class="size-5 text-gray-400" aria-hidden="true" />
                                        <ChevronDownIcon20 class="-mr-1 size-5 text-gray-400 hidden" aria-hidden="true" />
                                    </MenuButton>
                                </div>

                                <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
                                    <MenuItems class="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black/5 focus:outline-hidden">
                                        <div class="py-1">
                                            <MenuItem v-for="option in sortOptions" :key="option.value">
                                                <a
                                                    href="#"
                                                    @click="order_by = option.value"
                                                    :class="[order_by == option.value ? 'bg-gray-100 text-gray-900 outline-hidden' : 'text-gray-700', 'hover:bg-gray-50 block px-4 py-2 text-sm']">
                                                    {{ option.name }}
                                                </a>
                                            </MenuItem>
                                        </div>
                                    </MenuItems>
                                </transition>
                            </Menu>
                        </div>
                        <div class="ml-auto items-center rounded-md bg-white p-0.5 flex gap-0.5">
                            <button
                                @click.prevent="layout = 'list'"
                                type="button"
                                :class="[layout === 'list' ? 'bg-gray-100 text-gray-600' : 'text-gray-400 hover:text-gray-600', 'cursor-pointer rounded-md p-1 transition-all duration-150']"
                            >
                                <Bars4Icon class="size-5" aria-hidden="true" />
                                <span class="sr-only">Use list view</span>
                            </button>
                            <button
                                @click.prevent="layout = 'grid'"
                                type="button"
                                :class="[layout === 'grid' ? 'bg-gray-100 text-gray-600' : 'text-gray-400 hover:text-gray-600', 'cursor-pointer rounded-md p-1 transition-all duration-150']"
                            >
                                <Squares2X2IconMini class="size-5" aria-hidden="true" />
                                <span class="sr-only">Use grid view</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div
                    v-if="!isLoadingGalleries && showDeletedList && deletedGalleries.length && layout === 'grid'"
                    class="grid grid-cols-1 gap-y-4 sm:grid-cols-2 sm:gap-x-4 sm:gap-y-4 lg:grid-cols-4 lg:gap-x-4">
                    <div class="rounded-md bg-yellow-50 p-4 col-span-4">
                        <div class="flex">
                            <div class="shrink-0">
                                <ExclamationTriangleIcon class="size-5 text-yellow-400" aria-hidden="true" />
                            </div>
                            <div class="ml-3">
                                <h3 class="text-sm font-medium text-yellow-800">{{ $t('home.deletion_tip') }}</h3>
                            </div>
                        </div>
                    </div>

                    <template v-if="deletedGalleries.length">
                        <GalleryCardGridItemComponent
                            v-for="item in deletedGalleries"
                            :gallery="item"
                            :key="`deleting-gallery-item-${item.slug}`"
                            :is-deleting="true"
                            @restore-gallery="restore(item.slug)"
                            @delete-gallery="deleteFromDeletedList(item.slug)"
                        />
                    </template>
                </div>

                <div
                    v-if="isLoadingGalleries && !showDeletedList && layout === 'grid'"
                    class="grid grid-cols-1 gap-y-4 sm:grid-cols-2 sm:gap-x-4 sm:gap-y-4 lg:grid-cols-4 lg:gap-x-4"
                >
                    <GalleryItemLoaderComponent v-for="i in 4" :key="`gallery-loader-${i}`" />
                </div>

                <div
                    v-if="!isLoadingGalleries && !showDeletedList && layout === 'grid'"
                    class="grid grid-cols-1 gap-y-4 sm:grid-cols-2 sm:gap-x-4 sm:gap-y-4 lg:grid-cols-4 lg:gap-x-4">
                    <GalleryCardGridItemComponent
                        v-for="gallery in galleries"
                        :gallery="gallery"
                        :key="`gallery-item-${gallery.slug}`"
                        @delete-gallery="galleryDeleteConfirmation(gallery.slug)"
                        @pin-gallery="doPinGallery"
                        @unpin-gallery="doUnpinGallery"
                    />

                    <button
                        v-if="!hasGalleries && !isLoadingGalleries && !isSearching"
                        @click="openCreateGallery"
                        class="lg:col-span-2 lg:col-start-2 relative block w-full rounded-lg border-2 border-dashed border-gray-300 p-12 text-center hover:border-gray-400 cursor-pointer">

                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="mx-auto size-12 text-gray-400">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M3.75 9.776c.112-.017.227-.026.344-.026h15.812c.117 0 .232.009.344.026m-16.5 0a2.25 2.25 0 0 0-1.883 2.542l.857 6a2.25 2.25 0 0 0 2.227 1.932H19.05a2.25 2.25 0 0 0 2.227-1.932l.857-6a2.25 2.25 0 0 0-1.883-2.542m-16.5 0V6A2.25 2.25 0 0 1 6 3.75h3.879a1.5 1.5 0 0 1 1.06.44l2.122 2.12a1.5 1.5 0 0 0 1.06.44H18A2.25 2.25 0 0 1 20.25 9v.776" />
                        </svg>
                        <p class="mt-1 text-sm text-gray-500">{{ $t('home.empty_gallery.text') }}</p>
                        <span class="mt-2 block text-sm font-semibold text-gray-900">{{ $t('home.empty_gallery.button') }}</span>

                    </button>

                    <div v-if="!hasGalleries && !isLoadingGalleries && isSearching" class="col-span-1 sm:col-span-2 lg:col-span-4">
                        <div class="flex justify-center p-8 text-center">
                            <p class="text-sm text-gray-500">За вашим запитом пошуку галерей не знайдено</p>
                        </div>
                    </div>
                </div>

                <div v-if="isLoadingGalleries && !showDeletedList && layout === 'list'">
                    <GalleryListLoaderComponent />
                </div>

                <div v-if="!isLoadingGalleries && showDeletedList && deletedGalleries.length && layout === 'list'">
                    <GalleryListComponent
                        :galleries="deletedGalleries"
                        :is-loading="isLoadingGalleries"
                        :is-deleting="true"
                        @restore-gallery="restore"
                        @delete-gallery="deleteFromDeletedList"
                    />
                </div>
                <div v-if="!isLoadingGalleries && !showDeletedList && layout === 'list'">
                    <GalleryListComponent
                        :galleries="galleries"
                        :is-loading="isLoadingGalleries"
                        :is-search-empty="galleries.length === 0 && isSearching"
                        @delete-gallery="galleryDeleteConfirmation"
                        @pin-gallery="doPinGallery"
                        @unpin-gallery="doUnpinGallery"
                    />
                </div>

                <div ref="scrollSentinel" class="h-px w-full"></div>

                <div v-if="isLoadingMore && !showDeletedList" class="flex justify-center py-6">
                    <svg class="size-6 animate-spin text-gray-400" viewBox="0 0 24 24" fill="none">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 0 1 8-8V0C5.373 0 0 5.373 0 12h4z" />
                    </svg>
                </div>

                <div v-if="galleriesHasMore && !isLoadingMore && !isLoadingGalleries && !showDeletedList" class="flex justify-center py-6">
                    <button
                        @click="loadMore"
                        type="button"
                        class="rounded-md bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-xs ring-1 ring-gray-200 ring-inset hover:bg-gray-50 cursor-pointer"
                    >
                        {{ $t('home.load_more') }}
                    </button>
                </div>
            </div>

            <div class="w-full lg:w-4/12 order-1 lg:order-2 mb-3 px-2 hidden">
                <div class="sticky top-20">
                    <div class="rounded-md bg-royal-blue-50 p-4 shadow-sm">
                        <div class="flex">
                            <div class="shrink-0">
                                <InformationCircleIcon class="size-5 text-royal-blue-400" aria-hidden="true" />
                            </div>
                            <div class="ml-3 flex-1 md:flex md:justify-between">
                                <p class="text-sm text-royal-blue-700">Оновлений дизайн та додаткові функції вже доступні.</p>
                                <p class="mt-3 text-sm md:mt-0 md:ml-6">
                                    <a href="#" class="font-medium whitespace-nowrap text-royal-blue-700 hover:text-royal-blue-600">
                                        Деталі
                                        <span aria-hidden="true"> &rarr;</span>
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="bg-white shadow rounded-lg mt-4" v-if="user && user.storage">
                        <div class="p-4">
                            <div class="w-full bg-gray-200 h-2 rounded">
                                <div
                                    :class="{
                                      'bg-yellow-500': storageUsedPercent >= 90 && storageUsedPercent < 100,
                                      'bg-red-500': storageUsedPercent >= 100,
                                      'bg-royal-blue-500': storageUsedPercent < 90
                                    }"
                                    :style="{ width: `${Math.min(storageUsedPercent, 100)}%` }"
                                    class="h-full rounded"
                                ></div>
                            </div>
                            <div class="flex justify-between items-center mt-2">
                                <span>Використано:</span>
                                <span><strong>{{ storageUsed }}</strong> / {{ storageLimit }}</span>
                            </div>
                            <router-link
                                to="/subscription"
                                v-if="storageUsedPercent >= 90 || user.subscription_type === 'free'"
                                class="bg-royal-blue-500 hover:bg-blue-700 text-white w-full mt-2 py-2 px-4 rounded-lg text-center block"
                            >
                                Збільшити сховище
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <DeleteGalleryConfirmationModalComponent
        :open="isDeletingConfirmation"
        @close="isDeletingConfirmation = false"
        @confirmAction="deletingConfirmationGallerySlug ? doDeleteGallery(deletingConfirmationGallerySlug) : null"
        :title="$t('gallery_settings.delete_gallery.title')"
        :message="$t('gallery_settings.delete_gallery.confirmation')"
        :secondMessage="deletingConfirmationWarning"
        :buttonText="$t('gallery_settings.delete_gallery.button')"
        :isLoading="isDeletingGallery"
    />

    <DeleteGalleryConfirmationModalComponent
        :open="isDeletingFromDeletesListConfirmation"
        @close="isDeletingFromDeletesListConfirmation = false"
        @confirmAction="deletingConfirmationGallerySlug ? doDeleteGallery(deletingConfirmationGallerySlug) : null"
        :title="$t('gallery_settings.delete_gallery.title')"
        :message="$t('home.delete_confirmation')"
        :secondMessage="deletingConfirmationWarning ? $t('home.delete_confirmation_info') + ' ' + deletingConfirmationWarning : $t('home.delete_confirmation_info')"
        :buttonText="$t('gallery_settings.delete_gallery.button')"
        :isLoading="isDeletingGallery"
    />

    <CreateGalleryComponent
        :open="isCreateGalleryOpen"
        @close="closeCreateGallery"
    />
</template>

<script lang="ts">
import {defineComponent} from 'vue';

import {mapActions, mapGetters} from "vuex";
import {formatStorage} from "@/_helpers/formatters";
import GalleryItemLoaderComponent from "@/components/Loaders/GalleryItemLoaderComponent.vue";
import {checkBlackFridayUpgrade} from "@/data/requests/subscription";
import {
    Bars4Icon,
    InformationCircleIcon,
    Squares2X2Icon as Squares2X2IconMini,
    ChevronDownIcon as ChevronDownIcon20,
    ExclamationTriangleIcon,
    MagnifyingGlassIcon,
    XMarkIcon
} from '@heroicons/vue/20/solid'
import {restoreGallery, getStats} from "@/data/requests/gallery";
import {BarsArrowDownIcon} from "@heroicons/vue/16/solid";
import GalleryCardGridItemComponent from "@/components/Galleries/GalleryCardGridItemComponent.vue";
import GalleryListComponent from "@/components/Galleries/GalleryListComponent.vue";
import {Menu, MenuButton, MenuItem, MenuItems} from "@headlessui/vue";
import GalleryListLoaderComponent from "@/components/Loaders/GalleryListLoaderComponent.vue";
import DeleteGalleryConfirmationModalComponent
    from "@/components/Galleries/Modals/DeleteGalleryConfirmationModalComponent.vue";
import CreateGalleryComponent from "@/components/Galleries/CreateGalleryComponent.vue";

interface NavTab {
    name: string;
    count: number;
    current: boolean;
    action: () => void;
}

export default defineComponent({
    name: "HomePage",

    components: {
        CreateGalleryComponent,
        DeleteGalleryConfirmationModalComponent,
        GalleryListLoaderComponent,
        Menu, MenuButton, MenuItem, MenuItems,

        BarsArrowDownIcon,
        GalleryListComponent,
        GalleryCardGridItemComponent,
        GalleryItemLoaderComponent,
        InformationCircleIcon,
        Bars4Icon,
        MagnifyingGlassIcon,
        XMarkIcon,
        Squares2X2IconMini,
        ExclamationTriangleIcon,
        ChevronDownIcon20
    },

    data() {
        return {
            isLoadingGalleries: false,
            isLoadingMore: false,
            searchDebounceTimer: null as ReturnType<typeof setTimeout> | null,
            scrollObserver: null as IntersectionObserver | null,

            showDeletedList: false,

            layout: localStorage.getItem('galleries-layout') || 'grid',

            searchQuery: '',
            isMobileSearchOpened: false,

            isDeletingConfirmation: false,
            isDeletingFromDeletesListConfirmation: false,

            deletingConfirmationGallerySlug: null as string | null,
            deletingConfirmationWarning: '' as string,
            isDeletingGallery: false,

            isCreateGalleryOpen: false,

            blackFridayUpgradeAvailable: false,

            sortOptions: [
                {
                    name: this.$t('home.order_created'),
                    value: 'created',
                },
                {
                    name: this.$t('home.order_date'),
                    value: 'date',
                },
                {
                    name: this.$t('home.order_storage'),
                    value: 'storage',
                }
            ],

            order_by: 'created',
        };
    },

    computed: {
        ...mapGetters({
            galleries: "galleries/galleries",
            hasGalleries: "galleries/hasGalleries",
            galleriesHasMore: "galleries/galleriesHasMore",
            galleriesPage: "galleries/galleriesPage",
            galleriesTotal: "galleries/galleriesTotal",

            deletedGalleries: "galleries/deletedGalleries",

            user: "user/user"
        }),

        isSearching(): boolean {
            return this.searchQuery.trim() !== '';
        },

        storageUsed(): string {
            return formatStorage(this.user ? this.user.storage.used : 0, this.$t);
        },

        storageLimit(): string {
            return formatStorage(this.user ? this.user.storage.limit : 0, this.$t);
        },

        storageUsedPercent(): number {
            if(!this.user) {
                return 0;
            }

            return (this.user.storage.used / this.user.storage.limit) * 100;
        },

        blackFridayTermsUrl(): string {
            const locale = this.$i18n.locale === 'en' ? 'en' : 'uk';
            return locale === 'en' 
                ? 'https://gallera.io/en/blackfriday2025'
                : 'https://gallera.io/blackfriday2025';
        },

        tabs(): NavTab[] {
            const tabs = [
                {
                    name: this.$t("home.navigation.galleries"),
                    count: this.galleriesTotal,
                    current: !this.showDeletedList,
                    action: () => {
                        this.showDeletedList = false;
                    }
                },
            ];

            if(this.deletedGalleries.length) {
                tabs.push({
                    name: this.$t("home.navigation.deleted_galleries"),
                    count: this.deletedGalleries.length,
                    current: this.showDeletedList,
                    action: () => {
                        this.showDeletedList = true;
                    }
                });
            }

            return tabs;
        }
    },

    watch: {
        layout: {
            handler(newLayout) {
                localStorage.setItem('galleries-layout', newLayout);
            },
            immediate: true
        },
        order_by() {
            this.reloadGalleries();
        },
        searchQuery() {
            if(this.searchDebounceTimer) {
                clearTimeout(this.searchDebounceTimer);
            }

            this.searchDebounceTimer = setTimeout(() => {
                this.reloadGalleries();
            }, 400);
        },
        user: {
            handler(newUser) {
                // Викликаємо коли user завантажений
                if (newUser) {
                    // Невелика затримка, щоб переконатися що user повністю завантажений
                    setTimeout(() => {
                        this.checkBlackFridayUpgrade();
                    }, 100);
                }
            },
            immediate: true
        }
    },

    mounted() {
        this.fetchGalleries();
        // checkBlackFridayUpgrade викликається через watch на user з immediate: true

        this.$nextTick(() => {
            const sentinel = this.$refs.scrollSentinel as HTMLElement | undefined;

            if(sentinel) {
                this.scrollObserver = new IntersectionObserver((entries) => {
                    if(entries[0].isIntersecting) {
                        this.loadMore();
                    }
                }, {rootMargin: '400px'});

                this.scrollObserver.observe(sentinel);
            }
        });
    },

    beforeUnmount() {
        if(this.scrollObserver) {
            this.scrollObserver.disconnect();
        }

        if(this.searchDebounceTimer) {
            clearTimeout(this.searchDebounceTimer);
        }
    },

    methods: {
        ...mapActions({
            loadGalleries: "galleries/loadGalleries",
            loadDeletedGalleries: "galleries/loadDeletedGalleries",
            deleteGallery: "galleries/deleteGallery",
            pinGallery: "galleries/pinGallery",
            unpinGallery: "galleries/unpinGallery",
            fetchUser: "user/fetchUser",

            errorAlert: "alerts/error",
            successAlert: "alerts/success",
        }),

        publicUrl(url: string): string {
            return process.env.VUE_APP_PUBLIC_URL + url;
        },

        fetchGalleries() {
            if(! this.hasGalleries) {
                this.isLoadingGalleries = true;
            }

            this.loadGalleries({page: 1, sort: this.order_by, search: this.searchQuery})
                .then(() => {
                    this.loadDeletedGalleries()
                        .then(() => {
                            this.isLoadingGalleries = false;
                        })
                        .catch(({data}) => {
                            if(data.message) {
                                this.errorAlert({
                                    message: this.$t('home.errors.deleted_loading'),
                                    timeout: 30
                                })
                            }

                            this.isLoadingGalleries = false;
                        });
                })
                .catch(({data}) => {
                    if(data.message) {
                        this.errorAlert({
                            message: this.$t('home.errors.galleries_loading'),
                            timeout: 30
                        })
                    }

                    this.isLoadingGalleries = false;
                });
        },

        reloadGalleries() {
            this.isLoadingGalleries = true;

            this.loadGalleries({page: 1, sort: this.order_by, search: this.searchQuery})
                .then(() => {
                    this.isLoadingGalleries = false;
                })
                .catch(({data}) => {
                    if(data.message) {
                        this.errorAlert({
                            message: this.$t('home.errors.galleries_loading'),
                            timeout: 30
                        })
                    }

                    this.isLoadingGalleries = false;
                });
        },

        loadMore() {
            if(this.isLoadingMore || this.isLoadingGalleries || !this.galleriesHasMore || this.showDeletedList) {
                return;
            }

            this.isLoadingMore = true;

            this.loadGalleries({
                page: this.galleriesPage + 1,
                sort: this.order_by,
                search: this.searchQuery,
                append: true,
            })
                .then(() => {
                    this.isLoadingMore = false;
                })
                .catch(() => {
                    this.isLoadingMore = false;
                });
        },

        deleteFromDeletedList(gallerySlug: string) {
            this.deletingConfirmationGallerySlug = gallerySlug;
            this.deletingConfirmationWarning = '';
            this.isDeletingFromDeletesListConfirmation = true;
            this.loadDeletingConfirmationWarning(gallerySlug);
        },

        galleryDeleteConfirmation(gallerySlug: string) {
            this.deletingConfirmationGallerySlug = gallerySlug;
            this.deletingConfirmationWarning = '';
            this.isDeletingConfirmation = true;
            this.loadDeletingConfirmationWarning(gallerySlug);
        },

        loadDeletingConfirmationWarning(gallerySlug: string) {
            getStats(gallerySlug, (stats) => {
                if (this.deletingConfirmationGallerySlug !== gallerySlug) return;

                if (stats.downloads_count === 0 && stats.files_downloads_count === 0) {
                    this.deletingConfirmationWarning = this.$t('gallery_settings.delete_gallery.never_downloaded');
                } else if (stats.downloads_count === 0 && stats.files_downloads_count > 0) {
                    this.deletingConfirmationWarning = this.$t('gallery_settings.delete_gallery.partially_downloaded');
                } else {
                    this.deletingConfirmationWarning = '';
                }
            });
        },

        doDeleteGallery(gallerySlug: string) {
            if (this.isDeletingGallery) return;
            
            this.isDeletingGallery = true;
            
            this.deleteGallery({gallery: gallerySlug})
                .then(() => {
                    this.loadDeletedGalleries();
                    this.fetchUser({token: ''});

                    this.deletingConfirmationGallerySlug = null;
                    this.isDeletingConfirmation = false;
                    this.isDeletingFromDeletesListConfirmation = false;
                    this.isDeletingGallery = false;

                    if(this.deletedGalleries.length === 0) {
                        this.showDeletedList = false;
                    }

                }).catch(({data}) => {
                    this.isDeletingGallery = false;
                    
                    this.errorAlert({
                        message: this.$t('home.deleting_gallery', {message: data.message})
                    });
                });
        },

        restore(gallerySlug: string) {
            if (confirm(this.$t('home.restore_confirmation'))) {
                restoreGallery(gallerySlug, () => {
                    this.loadGalleries({page: 1, sort: this.order_by, search: this.searchQuery});
                    this.loadDeletedGalleries();
                    this.fetchUser({token: ''});
                }, (type, data) => {
                    this.errorAlert({
                        message: this.$t('home.restoring_gallery', {message: data.message})
                    });
                });
            }
        },

        doPinGallery(gallerySlug: string) {
            this.pinGallery({gallery: gallerySlug})
                .then(() => {
                    this.successAlert({
                        message: this.$t('home.pinned_gallery')
                    });
                }).catch(({data}) => {
                    this.errorAlert({
                        message: this.$t('home.pinning_gallery', {message: data.message})
                    });
                });
        },


        doUnpinGallery(gallerySlug: string) {
            this.unpinGallery({gallery: gallerySlug})
                .then(() => {
                    this.successAlert({
                        message: this.$t('home.unpinned_gallery')
                    });
                }).catch(({data}) => {
                this.errorAlert({
                    message: this.$t('home.pinning_gallery', {message: data.message})
                });
            });
        },

        toggleDeletedGalleries() {
            this.showDeletedList = !this.showDeletedList;
        },

        openCreateGallery() {
            this.isCreateGalleryOpen = true;
        },

        closeCreateGallery() {
            this.isCreateGalleryOpen = false;
        },

        checkBlackFridayUpgrade() {
            if (!this.user) {
                this.blackFridayUpgradeAvailable = false;
                return;
            }

            checkBlackFridayUpgrade((data) => {
                this.blackFridayUpgradeAvailable = data.is_active === true && data.can_upgrade === true;
            }, (type, error) => {
                // Помилка - не показуємо банер
                console.error('Black Friday upgrade check error:', type, error);
                this.blackFridayUpgradeAvailable = false;
            });
        }
    }
})
</script>

<style lang="scss" scoped>

</style>